import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import {orderBy} from "lodash"
import { getVeryShortCountLoadingSelector, getVeryShortCountSelector } from "./countSlice";
import CountGrid from "./CountGrid";
import { getDevicesSelector } from "../Devices/Slice";

interface RunningPeriodsWidgetProps{
    id: string;
    header: string
}

const CountGridWidget = (props:RunningPeriodsWidgetProps) =>{
    const [gridData, updateGridData] = useState([]);
    const [dataProcessed, setDataProcessed] = useState<boolean>(false);

    const deviceObjects = (useSelector(getDevicesSelector))
    const veryShortCount = useSelector(getVeryShortCountSelector);
    const loadingState = useSelector(getVeryShortCountLoadingSelector);

    useEffect(()=>{
        if(veryShortCount.length > 0){
            const sortedData = orderBy(veryShortCount,"count","desc")
            updateGridData(sortedData)
        }else{
            updateGridData([])
        }
        setDataProcessed(true);
    },[veryShortCount])

    useEffect(()=>{
        if (loadingState==="pending"){
            setDataProcessed(false)
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && veryShortCount.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    const handleRowClick = () =>{

    }

    if (!dataProcessed) return <Spinner text="data" />;
    if (gridData == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (gridData != null && gridData.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }

    return (
        <Fragment>
            <CountGrid data={gridData} clickHandler={handleRowClick}/>
        </Fragment>
        )
}

export default CountGridWidget;